import "../elements/file-picker";
import "../elements/toast-with-cookie";
import "../elements/validation-form";
import "../elements/global-nav";
import "../elements/global-search";
import "../elements/car-cost-calculator";
import "../elements/car-cost-chart";
import "../elements/car-cost-help-modal";
import "../Application/logManager";
import "../elements/dismissible-alert";
import "../elements/_radio-button-list";

import "../validation/validation";
import "../validation/requiredif";
import "../validation/requiredcombovalue";

// HTML has loaded
document.addEventListener("DOMContentLoaded", () => {

    // Add code here

}, false);

// Images, etc has loaded
window.addEventListener("load", () => {

    // Add code here

});

